import type { Editor } from "@tiptap/core"

export default {
  bold: (editor: Editor) => editor.chain().focus().toggleBold().run,
  italic: (editor: Editor) => editor.chain().focus().toggleItalic().run,
  underline: (editor: Editor) => editor.chain().focus().toggleUnderline().run,
  strike: (editor: Editor) => editor.chain().focus().toggleStrike().run,
  bulletList: (editor: Editor) => editor.chain().focus().toggleBulletList().run,
  orderedList: (editor: Editor) =>
    editor.chain().focus().toggleOrderedList().run,
  blockquote: (editor: Editor) => editor.chain().focus().toggleBlockquote().run,
  link: (editor: Editor) => {
    return () => {
      const previousUrl = editor.getAttributes("link").href
      const url: string = window.prompt("URL", previousUrl)
      // cancelled
      if (url === null) {
        return
      }
      // empty
      if (url === "") {
        editor.chain().focus().extendMarkRange("link").unsetLink().run()
        return
      }
      // update link
      editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: url })
        .run()
    }
  },
  unlink: (editor: Editor) => editor.chain().focus().unsetLink().run,
  code: (editor: Editor) => editor.chain().focus().toggleCode().run,
  codeBlock: (editor: Editor) => editor.chain().focus().toggleCodeBlock().run,
  undo: (editor: Editor) => editor.chain().focus().undo().run,
  redo: (editor: Editor) => editor.chain().focus().redo().run,
  image: (editor: Editor) => {
    return () => {
      const evt = new CustomEvent("insertimage")

      editor.view.dom?.parentElement?.dispatchEvent(evt)
    }
  },
  youtube: (editor: Editor) => {
    return () => {
      const url = prompt("Enter YouTube URL")

      if (!url) return
      editor.commands.setYoutubeVideo({
        src: url,
        width: 640,
        height: 480
      })
    }
  },
  vimeo: (editor: Editor) => {
    return () => {
      const url = prompt("Enter Vimeo URL")

      if (!url) return
      editor.commands.setVimeoVideo({
        src: url,
        width: 640,
        height: 480
      })
    }
  }
}
